//@ts-nocheck
/* 
 *  This file configuration.service.ts is part of HROne Inbox. The intelectual property owned by Uneecops Workplace Solution PVT. LTD.
 *  CopyrightYear: 2025  
 *  (C) 2015-2025. All Right reserved. Uneecops Workplace Solution PVT. LTD.
 *  
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { customValidations } from '../validators/validations.enum';

@Injectable()
export class ConfigurationService {

    envName = '';
    domainCode = '';
    base_url = '';
    chat_base_url = '';
    file_size_in_mb = 5;
    stripe_base_url = '';
    kommunicationAppId = '';
    allow_mixpanel = false;
    mixpanel_token = "";
    hashDomain: any;
    loginDomain: any;
    configData = null;
    redirect_to_hrone_app = '';
    constructor(
        public _httpClient: HttpClient,
    ) { }

    loadConfig(): any {
        const data = environment;
        this.configData = data;
        this.domainCode = this.getDomainHttp(data);
        this.envName = data.envName;
        this.base_url = data.base_url;
        this.chat_base_url = data.chat_base_url;
        this.stripe_base_url = data.stripe_base_url;
        this.mixpanel_token = data.mixpanel_token;
        this.allow_mixpanel = data.allow_mixpanel;
        this.redirect_to_hrone_app = data.redirect_to_hrone_app;
    }

    getDomainHttp(env) {
        if (env['envName'] === 'production') {
            const hd = this.getDomainFromUrlHash();
            localStorage.setItem('hashDomain', hd);
            this.hashDomain = hd;
            this.loginDomain = localStorage.getItem('loginDomain');

            if (this.isIP(location.origin)) {
                const paths: string[] = location.pathname.split('/').splice(1, 1);
                const basePath: string = (paths && paths[0]) || '';
                return basePath;
            } else {
                return location.hostname.split('.')[0];
            }

        } else {
            localStorage.setItem('hashDomain', '');
            return env['domainCode'];
        }
    }

    isIP(address) {
        const r =
            RegExp([
                '^https?:\/\/([a-z0-9\\.\\-_%]+:([a-z0-9\\.\\-_%])+?@)?',
                '((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\\.){3}(25[0-5]|2[0-4',
                '][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])?',
                '(:[0-9]+)?(\/[^\\s]*)?$'
            ].join(''), 'i');
        return r.test(address);
    }

    getDomainFromUrlHash() {
        let d = '';
        const domain = window.location.hash.substring(1);
        const hashD = localStorage.getItem('hashDomain');
        const regex = new RegExp(customValidations.AlphaNumericOnly);
        if (domain && domain != 'hrone' && regex.test(domain)) {
            d = domain;
        } else if (domain && domain == 'hrone') {
            d = '';
        } else if (hashD) {
            d = hashD;
        }
        return d;
    }
}